import { useState } from "react";
import { Box } from "@chakra-ui/react";
import Header from "../components/Header/index.js";
import Banner from "../components/Banner/index.js";
// import BannerEndVote from "../components/Banner/EndVote";
// import BannerResult from "../components/Banner/Result";
import Footer from "../components/Footer/index.js";
// import MusicMagic from "../components/MusicMagic";
// import Nostalgia from "../components/Nostalgia";
// import NaturePrints from "../components/NaturePrints";
import Steps2022 from "../components/Steps2022";
// import VoteFavorites from "../components/VoteFavorites";
import VoteModal from "../components/VoteModal";

import FormWrapper from "../components/FormWrapper/index.js";
import Vote from "../components/Vote/index.js";
import ContestTheme from "../components/ContestTheme/index.js";
import Rules from "../components/Rules/index.js";
import InfoAward from "../components/InfoAward/index.js";
import Jurors from "../components/Jurors/index.js";
import Steps from "../components/Steps/index.js";
import TitleSpoleto from "../components/Title";
import SubTitle from "../components/SubTitle";

const HomePage = () => {
  const [isVoteModalOpen, setVoteModalOpen] = useState(false);

  const toggleVoteModal = () => {
    setVoteModalOpen(!isVoteModalOpen);
  };

  return (
    <Box>
      <Header />
      <Box pos="relative" top="62px">
        <VoteModal isOpen={isVoteModalOpen} toggleVoteModal={toggleVoteModal} />
        <Banner toggleModal={toggleVoteModal} />
        {/* <BannerEndVote /> */}
        {/* <BannerResult /> */}
        {/* <FormWrapper /> */}
        {/* <Box bg="#EFEBE1" py="120px" id="inscricao">
          <TitleSpoleto color="#331F12">VOTAÇÃO ENCERRADA</TitleSpoleto>
          <SubTitle color="#331F12" mt={4}>
            Agora é cruzar os dedos, o resultado sai dia 08/07 aqui no site
            <br /> e nas nossas redes sociais.
          </SubTitle>
        </Box> */}
        <Vote />

        <ContestTheme />
        {/* <MusicMagic /> */}
        {/* <Nostalgia /> */}
        {/* <NaturePrints /> */}
        <Rules />
        <InfoAward />
        <Jurors />
        {/* <Steps />
        {/* <VoteFavorites toggleModal={toggleVoteModal} /> */}
        <Steps2022 />
        <Footer />
      </Box>
    </Box>
  );
};

export default HomePage;
